import { Component, OnInit, Renderer2, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import {
  ExcelService,
  SmartSmsRequestsService,
} from 'src/app/core/api/services';
import { DefaultSearchValueService } from 'src/app/core/services/default-search-value.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { DynamicTableService } from 'src/app/core/services/dynamic-table.service';
import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { SendSmartSmsDetailPage } from '../send-smart-sms-detail/send-smart-sms-detail.component';
import { SendSmartSmsRequestListComponent } from '../send-smart-sms-request/send-smart-sms-request-list.component';

@Component({
  selector: 'app-reseller-smart-sms',
  templateUrl: './reseller-smart-sms-request.html',
  imports: [BaseIndexModule, SendSmartSmsDetailPage],
})
export class ResellerSmartSmsRequestComponent
  extends SendSmartSmsRequestListComponent
  implements OnInit
{
  //#region Properties

  pageName = 'resellerSmartSmsRequests';
  pageId = 'resellerSmartSmsRequests';
  /* binding service endpoints */
  protected currentService = inject(SmartSmsRequestsService);
  paginationApiMethodName: string =
    this.currentService
      .smartSmsRequestsGetResellerSmartSmsRequestsWithPagination.name;

  //#endregion

  constructor(
    public dynamicTableService: DynamicTableService,
    public dynamicTabService: DynamicTabService,
    public smartSmsShareMem: SmartSmsShareMemoryService,
    protected translate: TranslateService,

    public dialog: MatDialog,
    protected renderer: Renderer2,
    public excelFileService: ExcelService,
    protected defaultSearchValueService: DefaultSearchValueService
  ) {
    super(
      dynamicTabService,
      smartSmsShareMem,
      translate,
      dialog,
      renderer,
      excelFileService,
      defaultSearchValueService
    );
  }

  //#region Api

  //#endregion
}
